import { createContext, useState, useContext } from 'react'
import { getItemFromLocalStorage, setItemToLocalStorage } from '../common/LocalStorage'

const ProfileContext = createContext()

export const ProfileProvider = ({ children }) => {
  const [roleGrade, setRoleGradeState] = useState(() => 
    getItemFromLocalStorage('userRoleGradeOverride') || null
  )
  const [center, setCenterState] = useState(() => 
    getItemFromLocalStorage('userCenterOverride') || null
  )

  const setRoleGrade = (grade) => {
    setRoleGradeState(grade)

    if (grade) {
      setItemToLocalStorage('userRoleGradeOverride', grade)
    } else {
      localStorage.removeItem('userRoleGradeOverride')
    }
    
    localStorage.removeItem('permissions')
  }

  const setCenter = (center) => {
    setCenterState(center)
    if (center) {
      setItemToLocalStorage('userCenterOverride', center)
      setItemToLocalStorage('localCenter', center)
    } else {
      localStorage.removeItem('userCenterOverride')
    }
  }

  const resetToOriginal = () => {
    setRoleGradeState(null)
    setCenterState(null)
    localStorage.removeItem('userRoleGradeOverride')
    localStorage.removeItem('userCenterOverride')
    localStorage.removeItem('localCenter')
    localStorage.removeItem('permissions')
  }

  return (
    <ProfileContext.Provider value={{ 
      roleGrade, setRoleGrade,
      center, setCenter,
      resetToOriginal
    }}>
      {children}
    </ProfileContext.Provider>
  )
}

export const useProfile = () => useContext(ProfileContext)